import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StateProvider } from './Middleware/context/StateProvider';
import { StateBusinessProvider } from './Middleware/context/StateBusinessProvider';
import { AuthProvider } from "./Middleware/context/AuthContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StateProvider> 
      <StateBusinessProvider>
      <AuthProvider>
        <App />
     </AuthProvider>
      </StateBusinessProvider>
    </StateProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();